module.exports = __webpack_public_path__ + "static/img/66.82c06ef9.jpg";